import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { store } from "../../../../store/configureStore";
import { toCamelCase } from "../../../../helpers/objectHelper";

//Available sourceelements that can with interaction resolve conditions
const navigate = element => {
  const attendee = store.getState().attendee;
  if (attendee && attendee.orders) {
    let order = attendee.orders[attendee.activePersonNo];
    if (element !== undefined && order !== undefined) {

      switch (element.type) {
        case elementConstants.FIELD:
          return fieldHandler(element, order);
        case elementConstants.QUESTION:
          return questionHandler(element, order);
        case elementConstants.EVENT:
          return eventHandler(element, order);
        default:
          return null;
      }
    }
  }
  return null;
};

const fieldHandler = (element, order) => {
  let type = order[toCamelCase(element.props.type)];
  if (type) {
    let val = type[toCamelCase(element.props.name)];
    if (val) {
      return val;
    }
  }
  return null;
};
const questionHandler = (element, order) => {
  if (element.props.type === "Text") {
    if (order.answer) {
      let answer = order.answer.find(a => a.questionId == element.id);
      if (answer && answer.answerRow && answer.answerRow.length > 0) {
        let row = answer.answerRow.find(ar => ar.questionOptionId == 0);
        if (row && !row.deleted) {
          return row.text;
        }
      }
    }
  }
  if (element.props.type === "Option") {
    if (element.props.options.length > 0) {
      const options = element.props.options;
      let checkedOptions = options.filter(o => {
        if (order.answer) {
          let answer = order.answer.find(a => a.questionId == element.id);
          if (answer && answer.answerRow && answer.answerRow.length > 0) {
            let row = answer.answerRow.find(
              ar => ar.questionOptionId == o.optionId
            );
            if (row && !row.deleted) {
              return true;
            }
          }
        }
        return false;
      });
      return checkedOptions;
    }
  }
  return null;
};
const eventHandler = (element, order) => {
  if (order.orderRow) {
    let row = order.orderRow.find(or => or.eventId == element.id);
    if (row && !row.deleted) {
      return true;
    }
  }
  return null;
};
export const conditionNavigator = {
  navigate
};
